export const getters = {
  isNewYear (state) {
    return false
  }
}
